<template>
  <div class="wrapper">
    <div class="topBar">
      <h1 class="title centerFont">{{ examData.examName }}</h1>
    </div>
    <div class="dataShowBox">
      <div class="monitorSide" v-if="recordDetailIfShow">
        <div class="monitorContent" v-if="examData.cameraInvigilation">
          <div class="imgContainer">
            <img
              class="monitorImg"
              :src="
                'https://' +
                $oss.options.bucket +
                '.' +
                $oss.options.endpoint.host +
                '/' +
                recordDetail.iconPath +
                monitorImgName
              "
            />
          </div>
          <img
            alt=""
            :src="
              'https://' +
              $oss.options.bucket +
              '.' +
              $oss.options.endpoint.host +
              '/' +
              item.h5IconPath +
              monitorPicName
            "
            class="monitorImg"
          />
          <!-- <video muted class="monitorVideo" id="monitorVideo" autoplay></video> -->
        </div>
        <div class="monitorContent" v-else>
          【当前未 <span class="blueFont">启用摄像头监考</span>】
        </div>
        <div class="studentDetailBar">
          <el-image fit="contain" :src="recordDetail.avatar"></el-image>
          <div class="detailForm">
            <div>考生姓名：{{ recordDetail.studentName }}</div>
            <div>考试进度：{{ recordDetail.answerProgress + "%" }}</div>
            <div>
              剩余时长：{{
                parseInt(recordDetail.leftTime / 3600) +
                ":" +
                parseInt(recordDetail.leftTime / 60) +
                ":" +
                (recordDetail.leftTime % 60)
              }}
            </div>
            <div>考试状态：{{ recordDetail.examStatus }}</div>
            <div>监控状态：{{ recordDetail.monitorStatus }}</div>
          </div>
        </div>
        <div class="actButtom">监考识别图片库</div>
        <div class="actButtom">作弊判断结果</div>
        <div class="actButtom">作弊信息记录 切屏0次 断开0次</div>
        <div class="actButtom">错误信息记录</div>
      </div>
      <div class="contentBox">
        <div class="titleBar">
          <div class="circleContainer" @click="typeChange(1)">
            <div class="leftSide">
              <div
                class="leftCircle"
                :style="{
                  transform:
                    'rotate(' +
                    (examData.doingRotate >= 135
                      ? examData.doingRotate - 180
                      : -45) +
                    'deg)',
                }"
              ></div>
            </div>
            <div class="rightSide">
              <div
                class="rightCircle"
                :style="{
                  transform:
                    'rotate(' +
                    (examData.doingRotate >= 135 ? 135 : examData.doingRotate) +
                    'deg)',
                }"
              ></div>
            </div>
            <div class="detailBox">
              <div
                :class="[
                  'detailInner',
                  searchCondition.type == 1 ? 'typeChosen' : '',
                ]"
                :style="{
                  background: searchCondition.type == 1 ? '#36aafd' : '#fff',
                }"
              >
                <div class="count">{{ examData.doingNum }}</div>
                <div class="title">正在考</div>
              </div>
            </div>
          </div>
          <div class="circleContainer" @click="typeChange(3)">
            <div class="leftSide">
              <div
                class="leftCircle"
                :style="{
                  transform:
                    'rotate(' +
                    (examData.noDoRotate >= 135
                      ? examData.noDoRotate - 180
                      : -45) +
                    'deg)',
                }"
              ></div>
            </div>
            <div class="rightSide">
              <div
                class="rightCircle"
                :style="{
                  transform:
                    'rotate(' +
                    (examData.noDoRotate >= 135 ? 135 : examData.noDoRotate) +
                    'deg)',
                }"
              ></div>
            </div>
            <div class="detailBox">
              <div
                :class="[
                  'detailInner',
                  searchCondition.type == 3 ? 'typeChosen' : '',
                ]"
              >
                <div class="count">{{ examData.noDoNum }}</div>
                <div class="title">未考(共{{ examData.totalNum }})</div>
              </div>
            </div>
          </div>
          <div class="circleContainer" @click="typeChange(2)">
            <div class="leftSide">
              <div
                class="leftCircle"
                :style="{
                  transform:
                    'rotate(' +
                    (examData.doneRotate >= 135
                      ? examData.doneRotate - 180
                      : -45) +
                    'deg)',
                }"
              ></div>
            </div>
            <div class="rightSide">
              <div
                class="rightCircle"
                :style="{
                  transform:
                    'rotate(' +
                    (examData.doneRotate >= 135 ? 135 : examData.doneRotate) +
                    'deg)',
                }"
              ></div>
            </div>
            <div class="detailBox">
              <div
                :class="[
                  'detailInner',
                  searchCondition.type == 2 ? 'typeChosen' : '',
                ]"
                :style="{
                  background: searchCondition.type == 2 ? '#36aafd' : '#fff',
                }"
              >
                <div class="count">{{ examData.doneNum }}</div>
                <div class="title">已考完</div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="statusBar centerFont">
          <div
            :class="[
              'statusBox',
              searchCondition.type == 1 ? 'statusChosenBox' : '',
            ]"
            @click="typeChange(1)"
          >
            <div class="blueFont largeFont">{{ examData.doingNum }}人</div>
            <div class="">正在考</div>
          </div>
          <div
            :class="[
              'statusBox',
              searchCondition.type == 2 ? 'statusChosenBox' : '',
            ]"
            @click="typeChange(2)"
          >
            <div class="blueFont largeFont">{{ examData.doneNum }}人</div>
            <div class="">已考</div>
          </div>
          <div
            :class="[
              'statusBox',
              searchCondition.type == 3 ? 'statusChosenBox' : '',
            ]"
            v-if="!examData.allowAllLogin"
            @click="typeChange(3)"
          >
            <div class="blueFont largeFont">{{ examData.noDoNum }}人</div>
            <div class="">未考</div>
          </div>
        </div> -->
        <div class="contentBar">
          <div class="searchBar" style="text-align: right; padding: 10px 2.5%">
            <el-button
              type="primary"
              size="mini"
              @click="
                $router.push({
                  name: 'recordList',
                  query: { id: $route.query.id },
                })
              "
              >考试记录</el-button
            >

            <el-button size="mini" type="primary" plain @click="toMonitorList"
              >查看所有考生监控</el-button
            >&ensp;
            <el-input
              placeholder="姓名"
              size="mini"
              style="width: 200px; text-align: left"
              v-model="searchCondition.name"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchExamRecordList"
              ></el-button>
            </el-input>
          </div>
          <div class="tableContainer">
            <el-table
              :data="recordList"
              style="width: 95%; margin: 10px 2.5% 0 2.5%"
              :height="tableHeight"
            >
              <el-table-column
                prop="studentName"
                label="姓名"
                v-if="searchCondition.type != 3"
              >
              </el-table-column>
              <el-table-column
                label="照片"
                width="100"
                v-if="searchCondition.type != 3"
              >
                <template slot-scope="scope" v-if="searchCondition.type != 3">
                  <el-image :src="scope.row.avatar"></el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="answerProgress"
                label="答题进度"
                v-if="searchCondition.type == 1"
              >
              </el-table-column>

              <el-table-column
                prop="getScore"
                label="得分"
                v-if="searchCondition.type == 2"
              >
              </el-table-column>

              <el-table-column
                prop="recordStartTime"
                label="考试时间"
                width="250"
                v-if="searchCondition.type == 1 || searchCondition.type == 2"
              >
              </el-table-column>
              <el-table-column
                prop="device"
                label="设备"
                v-if="searchCondition.type == 1"
              >
              </el-table-column>
              <el-table-column
                prop="getScoreRatio"
                label="得分比"
                v-if="searchCondition.type == 2"
              >
              </el-table-column>

              <el-table-column
                prop="consumeTime"
                label="用时"
                v-if="searchCondition.type == 2"
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="100"
                v-if="searchCondition.type == 1"
              >
                <template slot-scope="scope">
                  <i
                    class="el-icon-camera bigFont"
                    title="查看详情"
                    @click="getRecordDetail(scope)"
                  ></i>
                  <i
                    class="el-icon-s-release bigFont"
                    title="强制交卷"
                    @click="forceSubmit(scope)"
                  ></i>
                </template>
              </el-table-column>
              <el-table-column
                prop="noDoNum"
                label="未考人数"
                v-if="searchCondition.type == 3"
              >
              </el-table-column
              ><el-table-column
                prop="doneNum"
                label="已考人数"
                v-if="searchCondition.type == 3"
              >
              </el-table-column
              ><el-table-column
                prop="shouldDoNum"
                label="应考人数"
                v-if="searchCondition.type == 3"
              >
              </el-table-column>
              <el-table-column
                prop="studentGroupName"
                label="考生组"
                v-if="searchCondition.type == 3"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getExaminationRecord,
  getExaminationRecordList,
  forceSubmitexam,
} from "@/api/examination/examination.js";
import flvjs from "flv.js";
export default {
  data() {
    return {
      examData: {},
      recordList: [],
      recordDetail: {},
      recordDetailIfShow: false,
      searchCondition: {
        pageSize: 10,
        jumpPage: 1,
        name: "",
        examId: 33,
        type: 1,
      },
      intervalTime: {
        hour: 0,
        min: 0,
        sec: 0,
        frame: 0,
        intervalClock: null,
      },
      flvPlayer: null,
      tableHeight: document.body.clientHeight - 300,
    };
  },
  computed: {
    monitorImgName() {
      return (
        "/" +
        this.intervalTime.hour +
        "-" +
        this.intervalTime.min +
        "-" +
        this.intervalTime.sec +
        "-" +
        this.intervalTime.frame +
        ".png"
      );
    },
  },
  created() {},
  mounted() {
    // console.log(this.$oss.options.endpoint.href);
    this.searchCondition.examId = this.$route.query.id;
    this.searchExamRecordList();
  },
  methods: {
    forceSubmit({ row }) {
      this.$confirm(`确认强制交卷吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        forceSubmitexam({ recordId: row.recordId }).then((data) => {
          this.$message.success("强制交卷成功");
          this.searchExamRecordList();
        });
      });
    },
    searchExamRecordList() {
      getExaminationRecordList(this.searchCondition).then((data) => {
        console.log(data);
        this.recordList =
          this.searchCondition.type == 3
            ? data.detailNoDoDTOList
            : data.detailDTOList;
        data.totalNum = data.doingNum + data.doneNum + data.noDoNum;
        data.doingRotate = (data.doingNum / data.totalNum) * 360 - 45;
        data.noDoRotate = (data.noDoNum / data.totalNum) * 360 - 45;
        data.doneRotate = (data.doneNum / data.totalNum) * 360 - 45;
        Object.assign(this.examData, data);
        console.log(data.doingRotate, data.noDoRotate, data.doneRotate);
      });
    },
    timeInit() {
      let now = new Date();
      Object.assign(this.intervalTime, {
        hour: now.getHours(),
        min: now.getMinutes(),
        sec: now.getSeconds() - 4,
        frame: 0,
      });
    },
    getRecordDetail({ row }) {
      clearInterval(this.intervalTime.intervalClock);

      Object.assign(this.recordDetail, row);
      this.timeInit();

      this.recordDetailIfShow = true;
      // 一段时间矫正时间
      setInterval(this.timeInit, 120000);
      this.intervalTime.intervalClock = setInterval(() => {
        this.intervalTime.frame++;
        if (this.intervalTime.frame > 2) {
          this.intervalTime.frame = 0;
          this.recordDetail.leftTime--;
          this.intervalTime.sec++;
          if (this.intervalTime.sec == 60) {
            this.intervalTime.sec = 0;
            this.intervalTime.min++;
            if (this.intervalTime.min == 60) {
              this.intervalTime.min = 0;
              this.intervalTime.hour++;
              if (this.intervalTime.hour == 24) {
                this.intervalTime.hour = 0;
              }
            }
          }
        }
      }, 336);

      // setTimeout(this.monitorInit, 50);
      setTimeout(() => {
        this.monitorInit(row.videoUrl);
      }, 1000);
    },
    typeChange(type) {
      if (type == this.searchCondition.type) {
        return;
      } else {
        this.searchCondition.type = type;
        this.searchExamRecordList();
      }
    },
    monitorInit(liveUrl) {
      if (flvjs.isSupported()) {
        // this.monitorList.forEach((item) => {
        let videoElement = document.getElementById("monitorVideo");
        let flvPlayer = flvjs.createPlayer({
          type: "flv",
          isLive: true,
          // hasAudio: true,
          // hasVideo: true,
          // enableStashBuffer: true,
          url: liveUrl,
        });
        this.flvPlayer = flvPlayer;
        flvPlayer.attachMediaElement(videoElement);
        flvPlayer.load();
        flvPlayer.play();
        // });
      }
    },
    monitorPause() {
      this.flvPlayer.pause();
    },
    toMonitorList() {
      this.$router.push({
        name: "monitorList",
        query: { examId: this.searchCondition.examId },
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .topBar {
    padding: 15px 0;
    .title {
    }
  }
  .dataShowBox {
    display: flex;
    justify-content: space-around;
    .monitorSide {
      min-width: 280px;
      width: 30%;
      margin-left: 2%;
      .monitorContent {
        background: #999;
        height: 200px;
        text-align: center;
        line-height: 200px;
        display: flex;
        justify-content: space-between;
        .imgContainer {
          width: 48%;
        }
        .monitorImg {
          width: 100%;

          object-fit: contain;
        }
        .monitorVideo {
          flex: 1;
          width: 52%;
          object-fit: contain;
        }
      }
      .studentDetailBar {
        margin: 10px 0;
        display: flex;
        .el-image {
          flex: 1;
        }
        .detailForm {
          width: 60%;
          margin-left: 10px;
          display: block;
        }
      }
      .actButtom {
        border: 1px solid #999;
        background: #f7f7f7;
        padding: 4px 8px;
        border-radius: 2px;
      }
      .actButtom + .actButtom {
        margin-top: 4px;
      }
    }
    .contentBox {
      // width: 60%;
      flex: 1;
      background: #f7f7f7;
      margin: 0 3%;
      max-width: 90%;
      min-width: 400px;
      .statusBar {
        display: flex;
        border-bottom: 1px solid #409eff;
        padding: 10px 25% 0 25%;
        justify-content: center;

        .statusBox {
          // border: 1px solid #ccc;
          // border-bottom: 0;
          margin-bottom: -1px;
          flex: 1;
          padding: 10px 0;
          cursor: pointer;
        }
        .statusBox:hover {
          background: #eee;
        }
        .statusChosenBox {
          border: 1px solid #409eff !important;
          border-bottom: 1px solid #fff !important;
          background: #fff;
        }
      }
      .contentBar {
        background: #fff;
      }
    }
  }
}

.el-icon-camera:hover,
.el-icon-s-release:hover {
  color: #409eff;
}
.el-icon-camera,
.el-icon-s-release {
  cursor: pointer;
  margin: 0 4px;
}
.container {
  display: flex;
}

.titleBar {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  position: relative;
  padding: 40px;
}
.circleContainer {
  display: flex;
  width: 160px;
  height: 160px;
  position: relative;
  .leftSide {
    flex: 1;
    position: relative;
    overflow: hidden;
    .leftCircle {
      width: 200%;
      height: 100%;
      border: 6px solid #36aafd;
      border-top-color: #f7f7f7;
      border-left-color: #f7f7f7;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 0;
      transform: rotate(-45deg);
      transition: all 1s linear 1s;
    }
  }
  .rightSide {
    flex: 1;
    position: relative;
    overflow: hidden;

    .rightCircle {
      width: 200%;
      height: 100%;
      border: 6px solid #36aafd;
      border-right-color: #f7f7f7;
      border-bottom-color: #f7f7f7;
      border-radius: 50%;
      position: absolute;
      left: -100%;
      top: 0;
      transform: rotate(-45deg);
      transition: all 1s linear;
    }
  }
  .detailBox {
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .detailInner {
      width: 80%;
      height: 80%;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0 0 5px 5px #eee;
      padding: 15% 0;
    }
    .count {
      font-size: 28px;
      text-align: center;
    }
    .title {
      color: #ccc;
      text-align: center;
    }
  }
}
.typeChosen {
  background: #36aafd !important;
  box-shadow: 0 0 5px 40px rgba(54, 170, 253, 0.1) !important;
}
.typeChosen div {
  color: #fff !important;
}
</style>
